import React from 'react';
import { ChevronLeft, Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const MinimalTopBar = ({ title, onBack, showNotifications = true, notificationCount = 0 }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-40 bg-white/80 backdrop-blur-md border-b border-stone-200/50">
      <div className="max-w-7xl mx-auto px-4 h-14 flex items-center justify-between">
        {/* Left - Back Button */}
        <button
          onClick={handleBack}
          className="p-2 hover:bg-stone-100 rounded-full transition-colors"
        >
          <ChevronLeft className="w-5 h-5 text-stone-700" />
        </button>

        {/* Center - Title */}
        <h1 className="font-serif text-lg font-medium text-stone-900">
          {title}
        </h1>

        {/* Right - Notifications */}
        {showNotifications && (
          <button className="relative p-2 hover:bg-stone-100 rounded-full transition-colors">
            <Bell className="w-5 h-5 text-stone-700" />
            {notificationCount > 0 && (
              <span className="absolute top-1 right-1 w-2 h-2 bg-sacred-500 rounded-full" />
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default MinimalTopBar;